import { render } from "./Roles.vue?vue&type=template&id=bfb1a882&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=bfb1a882&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bfb1a882"

export default script